import { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useAppDispatch } from '../../../redux/hooks';
import { recordAnalysisVisit } from '../../../redux/slices/analysesVisits';
import {
  IAnalysisVisitMutation,
  IAnalysisVisitMutationVariables,
} from '../../../utils/apollo/graphqlSchema';
import printGraphqlErrors from '../../../utils/apollo/printGraphqlErrors';
import { assertNotNil } from '../../../utils/types';
import { VISIT_ANALYSIS } from '../../../utils/apollo/analysisVisit';

const useVisitAnalysisEffect = (builderId: string) => {
  const dispatch = useAppDispatch();

  const handleMutationComplete = ({
    analysisVisit,
  }: IAnalysisVisitMutation) => {
    const { errors, visit } = analysisVisit;

    if (printGraphqlErrors(errors)) {
      return;
    }

    assertNotNil(visit);
    dispatch(recordAnalysisVisit({ visit }));
  };

  const [visitAnalysisMutation] = useMutation<
    IAnalysisVisitMutation,
    IAnalysisVisitMutationVariables
  >(VISIT_ANALYSIS, {
    onCompleted: handleMutationComplete,
  });

  useEffect(() => {
    if (builderId) {
      visitAnalysisMutation({
        variables: {
          input: { analysisId: builderId },
        },
      });
    }
  }, [builderId, visitAnalysisMutation]);
};

export default useVisitAnalysisEffect;
